import React, { useState } from 'react';

import { useDesktopMediaQuery } from '@/hooks/useMediaQuery';

import Card from '@/components/tangerina/Card';

import FilterContainer from './FilterContainer';
import { TOption } from '@/components/global/Autocomplete';

type TProps = {
  onFilterChange: (filters: Record<string, string>) => void;
  isDisabled?: boolean;
  options: {
    title: string;
    card_key: string;
    comparator: string;
    tooltip?: string;
  }[];
  departureOptions: TOption[];
  arrivalOptions: TOption[];
  monthsOptions?: TOption[];
};

export function Filters({ onFilterChange, isDisabled, options, departureOptions, arrivalOptions, monthsOptions }: TProps) {
  const isDesktop = useDesktopMediaQuery();

  const filterOptions = {
    departure: options.find(option => option.card_key === 'departure'),
    arrival: options.find(option => option.card_key === 'arrival'),
    classtype: options.find(option => option.card_key === 'classtype'),
    months: options.find(option => option.card_key === 'months'),
    miles: options.find(option => option.card_key === 'miles'),
  }

  const [filters, setFilters] = useState({
    departure: '',
    arrival: '',
    classtype: '',
    months: '',
    miles: '',
  });

  const handleFilterChange = (field: string, value: string) => {
    setFilters(prev => {
      const newFilters = { ...prev, [field]: value };
      onFilterChange(newFilters);

      return newFilters;
    });
  };

  const handleArrowsClick = () => {
    setFilters(prev => {
      const newFilters = {
        ...prev,
        departure: prev.arrival,
        arrival: prev.departure,
      };
      onFilterChange(newFilters);

      return newFilters;
    });
  };

  const filterContainer = (
    <FilterContainer
      filters={filters}
      handleFilterChange={handleFilterChange}
      handleArrowsClick={handleArrowsClick}
      isDisabled={isDisabled}
      options={filterOptions}
      departureOptions={departureOptions}
      arrivalOptions={arrivalOptions}
      monthsOptions={monthsOptions}
    />
  )

  return (
    <div className="vitrine-template8__filters">
      {isDesktop ? (
        <div className="vitrine-template8__filters__card">
          <Card appearance="outline">
            {filterContainer}
          </Card>
        </div>
      ) : (
        <div className="vitrine-template8__filters__row">
          {filterContainer}
        </div>
      )}
    </div>
  );
}
